import { Alert, BetaPill, DatevLogo } from '@components'
import { useShowDatevComingSoon } from '@hooks'
import { SettingsSubPageLayout } from '@pages/SettingsPage/components/SettingsSubPageLayout'
import React from 'react'
import { FaArrowLeft, FaArrowRight, FaCog } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { DatevComingSoonCard } from './DatevComingSoonCard'

export const DatevIntegrationSettings: React.FC = () => {
  const { t } = useTranslation()
  const showDatevComingSoon = useShowDatevComingSoon()

  if (!showDatevComingSoon) {
    return null
  }

  return (
    <SettingsSubPageLayout
      title={
        <TitleRow>
          <DatevLogo height={36} />
          <span>{t('settings.datev.header')}</span>
          <BetaPill
            label={t('general.comingSoon.label')}
            tooltip={t('general.comingSoon.tooltip')}
          />
        </TitleRow>
      }
      subTitle={t('settings.datev.description')}
    >
      <Content>
        <Alert
          type="info"
          marginBottom={0}
          title={t('settings.datev.comingSoon.title')}
          description={t('settings.datev.comingSoon.description')}
        />
        <Cards>
          <DatevComingSoonCard
            icon={<FaArrowRight />}
            title={t('settings.datev.connectWrite')}
            description={t('settings.datev.writeDescription')}
            actionLabel={t('settings.datev.connectWrite')}
            actionIcon={<FaArrowRight />}
          />
          <DatevComingSoonCard
            icon={<FaArrowLeft />}
            title={t('settings.datev.connectRead')}
            description={t('settings.datev.readDescription')}
            actionLabel={t('settings.datev.connectRead')}
            actionIcon={<FaArrowLeft />}
          />
          <DatevComingSoonCard
            icon={<FaCog />}
            title={t('settings.datev.vatMapping.manageTitle')}
            description={t('settings.datev.vatMapping.manageTeaser')}
            actionLabel={t('settings.datev.vatMapping.open')}
            actionIcon={<FaCog />}
          />
        </Cards>
      </Content>
    </SettingsSubPageLayout>
  )
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}rem;
`

const TitleRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}rem;
  min-width: 0;
`

const Cards = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}rem;
`
